import { Component, ViewChild,HostListener } from '@angular/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { CommonmastersauditlogService } from './commonmastersauditlog.service';
import { GlobalMessage } from '../../utility/modals';

@Component({
  selector: 'app-commonmastersauditlog',
  templateUrl: './commonmastersauditlog.component.html',
  styleUrls: ['./commonmastersauditlog.component.css']
})
export class CommonmastersauditlogComponent {
  @ViewChild('dt') dt: Table;
  filtersData = {
    tmodifiedby: '',
    tdeletedby: '',
    taffectedrow: '',
    tdeletedrow: '',
    ttodate: '',
    tfromdate: '',
    taffectedmasterrow: '',
    page: 1,
    size: 10,
  }
  clickedFieldName: string = '';
  configId: string = '';
  sortDirection: string = '';
  rowsize: number = 10;
  totalRecords: number = 0;
  currentPageIndex: number = 0;
  commonScrollHeight = '';
  actionsList = [];
  // actionsList = [
  //   { label: 'Update', value: 'Update' },
  //   { label: 'Delete', value: 'Delete' }
  // ];
  formlistarray: Array<any> = [];
  _selectedColumns: any[];
  globalFilterFields: any[];
  selectedMasters: string | undefined;
  selectedActions: string | undefined;
  excel_paragraph = '';
  fromDate: string = '';
  toDate: string = '';
  vertlabelname = '';
  requirevertlabel = '';
  subvertlabelname = '';
  requiresubdeptlabel = '';
  subdeptlabelname = '';
  requiresubvertlabel = '';
  ishub = '';
  iscity = '';
  islocationtype = '';
  isregion = '';
  mastersList = [];
  exceldownloadModal = false;
  locationtypelabel = '';
  message: GlobalMessage = new GlobalMessage();
  todateerrorDIsplay = false;
  fromdateerrorDisplay = false;
  today: Date;
  masterErrorDisplay: boolean = false;
  actionErrorDisplay: boolean = false;
  searchTerm: string = ''; 
  deletedMasterLabel: String;
  modifiedMasterLabel = "Modified Row";
  modifiedByLabel =  "Modified By";

  orgType: String;

  constructor(
    public dialogService: DialogService, private CommonmastersauditlogService: CommonmastersauditlogService, private spinner: NgxSpinnerService, private utilityservice: Utilityservice
  ) {
    this.getDropdownList();
    this.today = new Date();
    this.excel_paragraph = this.message.downloadexcel_text;
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.utilityservice.getmasterconfigparams().subscribe((data: any) => {
      const responseArray = data?.[0]?.response;
      if (responseArray && responseArray.length > 0) {
        const config = responseArray[0];
        this.vertlabelname = config.vertlabelname;
        this.subvertlabelname = config.subvertlabelname;
        this.requirevertlabel = config.requirevertlabel;
        this.requiresubdeptlabel = config.requiresubdeptlabel;
        this.requiresubvertlabel = config.requiresubvertlabel;
        this.subdeptlabelname = config.subdeptlabelname;
        this.ishub = config.ishub;
        this.iscity = config.iscity;
        this.islocationtype = config.islocationtype;
        this.isregion = config.isregion;
        this.locationtypelabel = config.locationtypelabel; 
        this.mastersList = [
          { label: 'Application Configuration', value: 'configuration' },
          ...(config.iscity === 'Y' ? [{ label: 'City Master', value: 'gen_city' }] : []),
          { label: 'Currency Master', value: 'ct_currencymaster' },
          ...(config.orgtype === 'P' ? [{ label: 'Client Group', value: 'gen_group' }] : []), 
          { label: 'Department Master', value: 'department' },
          { label: 'Entity Master', value: 'company' },
          { label: 'Esign Transactions', value: 'esign_transactions' },
          { label: 'Financial Year Master', value: 'finyear' },
          ...(config.ishub === 'Y' ? [{ label: 'Hub Master', value: 'gen_hub' }] : []),
          { label: 'Invalid File Extensions', value: 'gen_invalidfileextensions' },          
          { label: 'Location Master', value: 'location' },
          ...(config.islocationtype === 'Y' ? [{ label: this.locationtypelabel, value: 'gen_locationmodel' }] : []),
          { label: 'Organisation Master', value: 'organisation' },
          ...(config.isregion === 'Y' ? [{ label: 'Region Master', value: 'gen_region' }] : []),
          { label: 'Signatory Details Master', value: 'gen_signatory' },
          ...(config.requiresubdeptlabel === 'Y' ? [{ label: this.subdeptlabelname, value: 'gen_subdepartment' }] : []),
          ...(config.requiresubvertlabel === 'Y' ? [{ label: this.subvertlabelname, value: 'gen_subvertical' }] : []),
          { label: 'User Master', value: 'users' },
          //{ label: 'User Master (Unlicensed)', value: 'gen_unlicensedusers' },
          { label: 'User Additional Mapping', value: 'gen_usermapping' },
          { label: 'User Product Role Master', value: 'userxproductxrole' },
          ...(config.requirevertlabel === 'Y' ? [{ label: this.vertlabelname, value: 'vertical' }] : []),
        ].sort((a, b) => a.label.localeCompare(b.label));
      }
    });
  }
  options = [{ label: 10, value: 10 }];
  paginatorArray = [];
  ref: DynamicDialogRef | undefined;
  selectedModifedBy: any = null;
  selectedModifedRow: any = null;
  selectedDeletedByRow: any = null;
  selectedAffectedMasterRow: any = null;
  selectedDeletedMasterRow: any = null;
  filterdeletedbydata: Array<any> = [];
  filtermodifedbydata: Array<any> = [];
  filterdeletedmasterrow: Array<any> = [];
  filteraffecteddata: Array<any> = [];
  filteraffectedmastedata: Array<any> = [];
  optionFieldName: string = '';
  masterOptionFieldName: string = '';
  userrole: any;
  userid: any;

  setOptionFieldName() {
    switch (this.selectedMasters) {
      case 'vertical':
        this.optionFieldName = 'verticalAffected';
        break;
      case 'userxproductxrole':
        this.optionFieldName = 'affectedTo';
        break;
      case 'users':
        this.optionFieldName = 'affectedTo';
        break;
      case 'gen_subvertical':
        this.optionFieldName = 'affectedSubVertical';
        break;
      case 'gen_subdepartment':
        this.optionFieldName = 'affectedSubDepartment';
        break;
      case 'gen_signatory':
        this.optionFieldName = 'affectedSignatory';
        break;
      case 'gen_region':
        this.optionFieldName = 'affectedRegion';
        break;
      case 'organisation':
        this.optionFieldName = 'affectedOrganisation';
        break;
      case 'gen_city':
        this.optionFieldName = 'affectedCity';
        break;
      case 'ct_currencymaster':
        this.optionFieldName = 'affectedCurrency';
        break;
      case 'configuration':
        this.optionFieldName = 'product';
        break;
      case 'department':
        this.optionFieldName = 'affectedDepartment';
        break;
      case 'company':
        this.optionFieldName = 'affectedCompany';
        break;
      case 'finyear':
        this.optionFieldName = 'affectedFinYr';
        break;
      case 'gen_hub':
        this.optionFieldName = 'affectedHub';
        break;
      case 'location':
        this.optionFieldName = 'affectedLocation';
        break;
      case 'gen_locationmodel':
        this.optionFieldName = 'affectedLocationModel';
        break;
      case 'gen_invalidfileextensions':
      case 'gen_group':
      case 'gen_usermapping':
      case 'gen_unlicensedusers':
        this.optionFieldName = 'modifiedRow';
        break; 
    }
  }

  setMasterOptionFieldName() {
    this.modifiedByLabel = "Modified By";
    if (this.selectedActions == "Update") {
      switch (this.selectedMasters) {
        case 'userxproductxrole':
          this.masterOptionFieldName = 'affectedProduct';
          break;
        case 'gen_subvertical':
          this.masterOptionFieldName = 'verticalAffected';
          break;
        case 'gen_subdepartment':
          this.masterOptionFieldName = 'affectedDepartment';
          break;
      }
    }

    if (this.selectedActions == "Delete") {
      switch (this.selectedMasters) {
        case 'gen_subvertical':
          this.masterOptionFieldName = 'verticalAffected';
          break;
        case 'gen_subdepartment':
          this.masterOptionFieldName = 'departmentName';
          this.deletedMasterLabel = "Affected Department";
          break;
        case 'esign_transactions':
          this.masterOptionFieldName = 'product';
          this.deletedMasterLabel = "Affected Product";
          break;
        case 'gen_usermapping':
          this.masterOptionFieldName = 'affectedUsers';
          this.deletedMasterLabel = "Affected User";
          break;
      }
    }

    if (this.selectedActions == "Insert") { 
      switch (this.selectedMasters) { 
        case 'gen_usermapping':
          this.masterOptionFieldName = 'affectedUsers';
          this.modifiedMasterLabel = "Affected User";
          this.modifiedByLabel = "Added By";
          break;
      }
    }
  }

  buildPayload(callType: string): any {
    const payload: any = {};
    payload.action = this.selectedActions;
    payload.tableName = this.selectedMasters;

    if (callType === "sort") {
      payload.sortDirection = this.sortDirection;
      payload.sortField = this.clickedFieldName;
    }

    if (this.selectedActions === "Update") {
      payload.modifiedRow = this.selectedModifedRow ?? '';
      payload.modifiedbyname = this.selectedModifedBy ?? '';
      if (this.selectedMasters === "gen_subdepartment" || this.selectedMasters === "gen_subvertical" || this.selectedMasters == "userxproductxrole") {
        payload.affectedMasterRow = this.selectedAffectedMasterRow
      }

    }
    else if (this.selectedActions === "Delete") {
      payload.deletedbyname = this.selectedDeletedByRow ?? '';
      payload.affectedMasterRow = this.selectedDeletedMasterRow ?? '';
    }
    else if (this.selectedActions === "Insert") {
      payload.modifiedRow = this.selectedModifedRow ?? '';
      payload.modifiedbyname = this.selectedModifedBy ?? '';
    }

    if (this.filtersData['tfromdate']) {
      payload.fromDate = this.filtersData['tfromdate'];
    }
    if (this.filtersData['ttodate']) {
      payload.toDate = this.filtersData['ttodate'];
    }

    Object.keys(payload).forEach(key => {
      const val = payload[key];
      if (val === '' || val == null) {
        delete payload[key];
      }
    });

    return payload;
  }

  getDropdownList() {
    this.spinner.show();
    const payload: any = {};
    payload.configId = this.configId;
    payload.tableName = this.selectedMasters;
    payload.fromDate = this.filterinput.fromdate ? moment(this.filterinput.fromdate).format('YYYY-MM-DD') : '';
    payload.toDate = this.filterinput.todate ? moment(this.filterinput.todate).format('YYYY-MM-DD') : '';
    if (this.selectedActions == "Update") {

      if (this.filtersData['tmodifiedby']) {
        payload.modifiedbyname = this.filtersData['tmodifiedby'];
      }
      if (this.filtersData['taffectedrow']) {
        payload.modifiedRow = this.filtersData['taffectedrow'];
      }

      // screens with parent data
      if (this.selectedMasters == "gen_subdepartment" || this.selectedMasters === "gen_subvertical" || this.selectedMasters === "userxproductxrole") {
        if (this.filtersData['taffectedmasterrow']) {
          payload.affectedMasterRow = this.filtersData['taffectedmasterrow'];
        }

        const modifiedby$ = this.CommonmastersauditlogService.getmodifiedby(payload);
        const modifiedrow$ = this.CommonmastersauditlogService.getmodifiedrow(payload);
        const affectedmasterow$ = this.CommonmastersauditlogService.getMasterRow(payload);

        forkJoin([modifiedby$, modifiedrow$, affectedmasterow$]).subscribe(
          ([modifiedByRes, modifiedRowRes, masterRowRes]) => {
            this.filtermodifedbydata = modifiedByRes;
            this.filteraffecteddata = modifiedRowRes;
            this.filteraffectedmastedata = masterRowRes;
            this.spinner.hide();
          },
          error => {
            console.error('Error fetching dropdown data', error);
            this.spinner.hide();
          }
        );

      }

      // screen with single filter
      else { 
        const modifiedby$ = this.CommonmastersauditlogService.getmodifiedby(payload);
        const modifiedrow$ = this.CommonmastersauditlogService.getmodifiedrow(payload);

        forkJoin([modifiedby$, modifiedrow$]).subscribe(
          ([modifiedByRes, modifiedRowRes]) => {
            this.filtermodifedbydata = modifiedByRes;
            this.filteraffecteddata = modifiedRowRes;
            this.spinner.hide();
          },
          error => {
            console.error('Error fetching dropdown data', error);
            this.spinner.hide();
          }
        );
      }
    }


    else if (this.selectedActions == "Delete") {
      if (this.filtersData['tdeletedby']) {
        payload.deletedByName = this.filtersData['tdeletedby'];
      }

      // screens with parent data
      if (this.selectedMasters == "gen_subdepartment" || this.selectedMasters === "gen_subvertical" || this.selectedMasters === "esign_transactions"
        || this.selectedMasters === "gen_usermapping"
      ) {
        if (this.filtersData['taffectedmasterrow']) {
          payload.affectedMasterRow = this.filtersData['taffectedmasterrow'];
        }
        const deletedMasterRow$ = this.CommonmastersauditlogService.getDeletedMasterRow(payload);
        const deletedby$ = this.CommonmastersauditlogService.getdeletedby(payload);
        forkJoin([deletedMasterRow$, deletedby$]).subscribe(
          ([deletedMasterDataRes, deletedByRes]) => {
            this.filterdeletedbydata = deletedByRes;
            this.filterdeletedmasterrow = deletedMasterDataRes;

            this.spinner.hide();
          },
          error => {
            console.error('Error fetching dropdown data', error);
            this.spinner.hide();
          }
        );

      }
      // screen with single filter
      else {
        const deletedby$ = this.CommonmastersauditlogService.getdeletedby(payload);
        forkJoin([deletedby$]).subscribe(
          ([deletedByRes]) => {
            this.filterdeletedbydata = deletedByRes;
            this.spinner.hide();
          },
          error => {
            console.error('Error fetching dropdown data', error);
            this.spinner.hide();
          }
        );
      }
    }
    if (this.selectedActions == "Insert") {

      if (this.filtersData['tmodifiedby']) {
        payload.modifiedbyname = this.filtersData['tmodifiedby'];
      }
      if (this.filtersData['taffectedrow']) {
        payload.modifiedRow = this.filtersData['taffectedrow'];
      }

        const modifiedby$ = this.CommonmastersauditlogService.getmodifiedby(payload);
        const modifiedrow$ = this.CommonmastersauditlogService.getmodifiedrow(payload);

        forkJoin([modifiedby$, modifiedrow$]).subscribe(
          ([modifiedByRes, modifiedRowRes]) => {
            this.filtermodifedbydata = modifiedByRes;
            this.filteraffecteddata = modifiedRowRes;
            this.spinner.hide();
          },
          error => {
            console.error('Error fetching dropdown data', error);
            this.spinner.hide();
          }
        ); 
    }
    else {
      this.spinner.hide();
    }
  }


  refreshFilters() {
    this.spinner.show();

    this.filtersData.tmodifiedby = '';
    this.filtersData.tdeletedby = '';
    this.filtersData.taffectedrow = '';
    this.filtersData.tdeletedrow = '';
    this.filtersData.taffectedmasterrow = '';

    this.selectedModifedBy = null;
    this.selectedModifedRow = null;
    this.selectedDeletedByRow = null;
    this.selectedDeletedMasterRow = null;
    this.selectedAffectedMasterRow = null;

    this.filterinput.fromdate = null;
    this.filterinput.todate = null;

    this.filtersData.tfromdate = '';
    this.filtersData.ttodate = '';
    this.getTableData(this.selectedActions);
    this.getDropdownList();
    this.errorDIsplay = false;  
    this.todateerrorDIsplay = false;
    this.fromdateerrorDisplay = false;
    this.spinner.hide();
  }


  getTableData(action: string, callback?: () => void): void {
    this.selectedActions = action;
    const payload: any = {};
    payload.action = action;
    const currentPageSize = this.rowsize;
    payload.tableName = this.selectedMasters;
    this.formlistarray = [];
    this.CommonmastersauditlogService.getTableData(payload).subscribe((data) => {
      if (data && data.length > 0) {
        const tableBlock = data[0];
        this.formlistarray = tableBlock.tableData || [];
        this.configId = tableBlock.configId;
        this.options = this.utilityservice.getOptionDropdown(this.formlistarray.length);
        this.paginatorArray = this.options.map(e => e.value);
        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }
        this.rowsize = currentPageSize;
        this.totalRecords = this.formlistarray.length;

        const tableColumnsStr = tableBlock.serverSideColumns || '';
        const tableColumnsHeader = tableBlock.tableColumns || '';
        this.dynamiccols(tableColumnsStr, tableColumnsHeader);

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      }
      this.spinner.hide();
      if (callback) {
        callback();
      }
    });
  }

  getConfiguration(master: string, action: string): void {
    this.errorDIsplay = false;  
     this.masterErrorDisplay = false;
    this.actionErrorDisplay = false;    

    if (!master) {
      this.masterErrorDisplay = true;
    }

    if (!action) {
      this.actionErrorDisplay = true;
    }  

    if (master === 'configuration' || master === 'organisation') {
      this.selectedActions = "Update";
      action = "Update";
    } 

    if (master === 'esign_transactions'  ) {
      this.selectedActions = "Delete";
      action = "Delete";
    } 
    if (master === 'gen_usermapping') {
      this.actionsList = [
        { label: 'Update', value: 'Update' },
        { label: 'Delete', value: 'Delete' },
        { label: 'Insert', value: 'Insert' }
      ];
    } else {
      this.actionsList = [
        { label: 'Update', value: 'Update' },
        { label: 'Delete', value: 'Delete' }
      ];

      if (this.selectedActions === 'Insert') {
        this.selectedActions = undefined;
      }
    }

     if (!this.selectedMasters || !this.selectedActions) {
      return;
    }

    this.getTableData(action, () => {
      this.getDropdownList();
      this.refreshFilters();
      this.setOptionFieldName();
      this.setMasterOptionFieldName();
    });
  }


  onHeaderClick(fieldName: string, event: MouseEvent): void {
    const currentSortField = this.dt?.sortField;
    const currentSortOrder = this.dt?.sortOrder;
    this.clickedFieldName = fieldName;

    if (fieldName === currentSortField) {
      this.sortDirection = currentSortOrder === 1 ? 'ASC' : currentSortOrder === -1 ? 'DESC' : '';
    } else {
      this.sortDirection = 'none';
    }
    this.getFilteredTableData("sort");
  }


  getFilteredTableData(callType: string): void {
    const payload = this.buildPayload(callType);
    Object.keys(payload).forEach(key => {
      const val = payload[key];
      if (val === '' || val == null) {
        delete payload[key];
      }
    });
    const currentPageSize = this.rowsize;
    this.formlistarray = [];
    this.CommonmastersauditlogService.getTableData(payload).subscribe((data) => {
      if (data && data.length > 0) {
        const tableBlock = data[0];
        this.formlistarray = tableBlock.tableData || [];
        this.totalRecords = this.formlistarray.length;
        const totalRecords = this.formlistarray.length;
        this.options = this.utilityservice.getOptionDropdown(totalRecords);
        if (totalRecords < 10) {
          this.paginatorArray = [totalRecords];
        } else {
          this.paginatorArray = this.options.map(e => e.value);
          if (!this.paginatorArray.includes(currentPageSize)) {
            this.paginatorArray.push(currentPageSize);
            this.paginatorArray.sort((a, b) => a - b);
          }
        }
        this.rowsize = currentPageSize;
        this.totalRecords = totalRecords;
        const tableColumnsStr = tableBlock.serverSideColumns || '';
        const tableColumnsHeader = tableBlock.tableColumns || '';
        this.dynamiccols(tableColumnsStr, tableColumnsHeader);
        this.currentPageIndex = 0;
        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      }
      this.spinner.hide();
    });
  }

  getParams2(event, label) {
    if (label == 'Modifed By') {
      this.filtersData['tmodifiedby'] = event.value
    }
    if (label == 'Modifed Row') {
      this.filtersData['taffectedrow'] = event.value
    }
    if (label == 'Deleted By') {
      this.filtersData['tdeletedby'] = event.value
    }

    if (label == 'Master Row') {
      this.filtersData['taffectedmasterrow'] = event.value
    }

    if (label == 'From Date') {
      this.filtersData['tfromdate'] = event.value
    }
    if (label == 'To Date') {
      this.filtersData['ttodate'] = event.value
    }
    this.getDropdownList();
    this.getFilteredTableData("");
  }

  dynamiccols(tableColumnsStr: string, tableColumnsHeader: string) {
    if (!tableColumnsStr || !tableColumnsHeader) {
      this._selectedColumns = [];
      this.globalFilterFields = [];
      return;
    }

    const columnFields = tableColumnsStr.split(',').map(col => col.trim());
    const columnHeaders = tableColumnsHeader.split(',').map(header => header.trim());

    this._selectedColumns = columnFields.map((field, index) => {
      let header = columnHeaders[index];

      if (header.toLowerCase() === 'modified vertical' || header.toLowerCase() === 'vertical name') {
        header = this.vertlabelname;
      }

      if (header.toLowerCase() === 'sub vertical name') {
        header = this.subvertlabelname;
      }

      if (header.toLowerCase() === 'sub department name') {
        header = this.subdeptlabelname;
      }

      return {
        field: field,
        header: header,
        isChecked: true,
        width: '150px',
        class: ''
      };
    });

    this.globalFilterFields = columnFields;
  }


  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }


  excelDownload() {
    const payload = this.buildPayload('');
    this.CommonmastersauditlogService.getExcelData(payload).subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Common Audit Log.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
      Swal.fire('File downloaded successfully! ', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');
    });
  }

  errorDIsplay = false;
  filterinput = new Filterreq()
   getdates(event) {
    this.fromdateerrorDisplay = false;
    this.todateerrorDIsplay = false;
    this.errorDIsplay = false;

    if (event.fromdate && !event.todate) {
      this.todateerrorDIsplay = true;
      return;
    }

    if (event.todate && !event.fromdate) {
      this.fromdateerrorDisplay = true;
      return;
    }


    if (event.fromdate !== '' && event.todate !== '') {
      if (event.fromdate <= event.todate) {
        this.errorDIsplay = false;
        this.filtersData['fromdate'] = moment(event.fromdate).format('YYYY-MM-DD');
        this.filtersData['todate'] = moment(event.todate).format('YYYY-MM-DD');
      } else {
        this.errorDIsplay = true;
      }
    }
  }

  onclear(event) {
    this.fromdateerrorDisplay = false;
    this.todateerrorDIsplay = false;
    if (event.todate == null || event.fromdate == null) {
      this.errorDIsplay = false;
      this.filtersData['tfromdate'] = ''; this.filtersData['ttodate'] = '';
    }

    if (!event.fromdate && event.todate) {
      this.fromdateerrorDisplay = true;

      this.filtersData['fromdate'] = '';
    }
    if (!event.todate && event.fromdate) {
      this.todateerrorDIsplay = true;

      this.filtersData['todate'] = '';
    }

  }

  onDateChange(): void {
    this.filterinput.fromdate = this.filterinput.fromdate ? this.filterinput.fromdate : null;
    this.filterinput.todate = this.filterinput.todate ? this.filterinput.todate : null;

    if (this.filterinput.fromdate && this.filterinput.todate) {
      this.filtersData['tfromdate'] = moment(this.filterinput.fromdate).format('YYYY-MM-DD');
      this.filtersData['ttodate'] = moment(this.filterinput.todate).format('YYYY-MM-DD');

      this.getDropdownList();
      this.getFilteredTableData("");
    } else {
      return
      // Swal.fire({
      //   icon: 'warning',
      //   text: 'Please select both From and To Dates',
      // });
    }
  }

  getModifiedByTooltip(): string {
    const selected = this.filtermodifedbydata.find(item => item.updatedBy === this.selectedModifedBy);
    return selected ? selected.updatedBy : 'Select Modified By';
  }


  getModifiedRowTooltip(): string {
    if (!this.optionFieldName || !this.selectedModifedRow) return 'Select Modified Row';
    const selected = this.filteraffecteddata.find(
      item => item[this.optionFieldName] === this.selectedModifedRow
    );
    return selected ? selected[this.optionFieldName] : 'Select Modified Row';
  }

  getDeletedByTooltip(): string {
    const selected = this.filterdeletedbydata.find(item => item.deletedBy === this.selectedDeletedByRow);
    return selected ? selected.deletedBy : 'Select Deleted By';
  }

  getAffectedDataTooltip(): string {
    if (!this.masterOptionFieldName || !this.selectedAffectedMasterRow) return 'Select';
    const selected = this.filteraffectedmastedata.find(
      item => item[this.masterOptionFieldName] === this.selectedAffectedMasterRow
    );

    return selected ? selected[this.masterOptionFieldName] : 'Select';
  }
  

  getDeletedMasterDataTooltip(): string {
    if (!this.masterOptionFieldName || !this.selectedDeletedMasterRow) return 'Select';
    const selected = this.filterdeletedmasterrow.find(
      item => item[this.masterOptionFieldName] === this.selectedDeletedMasterRow
    );

    return selected ? selected[this.masterOptionFieldName] : 'Select';
  }

   getSelectedMasterTooltip(): string {
    if (!this.selectedMasters) return 'Select a Master';
    const selected = this.mastersList.find(item => item.value === this.selectedMasters);
    return selected ? selected.label  : 'Select a Master';
  }

  getSelectedActionTooltip(): string {
    if (!this.selectedActions) return 'Select an Action';
    const selected = this.actionsList.find(item => item.value === this.selectedActions);
    return selected ? selected.label  : 'Select an Action';
  }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }



}
export class Filterreq {
  fromdate: string = '';
  todate: string = '';
  page = 1;
  size = 10;
}